'use client';

import a__default from "react";
import { ButtonGroup } from "../ButtonGroup/ButtonGroup.js";
import { classNames } from "../../utils/styles/classNames.js";
import { mainBg, buttons } from "./InlineNotification.css.js";
function ActionButtons({ actions, variant }) {
  if (actions.length === 0) return null;
  return /* @__PURE__ */ a__default.createElement("div", { className: classNames(buttons, mainBg[variant]) }, /* @__PURE__ */ a__default.createElement(ButtonGroup, { buttons: actions, size: "sm" }));
}
export {
  ActionButtons
};
